import { user as typeUser } from '../types';
import deepCopy from '../../../util/deepCopy';
import merge from 'deepmerge';

const initialState = {
    user: {
        activated: null,
        superUser: null,
        shouldChangePassword: null,
        lastLogin: null,
        tfaLoginTries: null,
        tfaLockedUntil: null,
        id: null,
        name: null,
        email: null,
        avatar: null,
        hasAccessToMultipleAccounts: null,
        rights: [],
        authHeader: null
    }
};
const state = deepCopy(initialState);

const getters = {
    [typeUser.getters.get]: state => {
        return state.user === initialState ? null : state.user;
    }
};

const mutations = {
    [typeUser.mutations.set]: (state, user) => {
        if (!user.rights || user.rights.length > 0)
            state.user.rights = [];
        state.user = merge(state.user, user); // Properties in user have prio over properties in state.user
    },
    [typeUser.mutations.reset]: (state) => {
        Object.keys(initialState).forEach(key => {
            state[key] = initialState[key];
        });
    },
    [typeUser.mutations.hasAccessToMultipleAccounts]: (state, newHasAccessToMultipleAccounts) => {
        state.user.hasAccessToMultipleAccounts = newHasAccessToMultipleAccounts;
    }
};

const actions = {
    [typeUser.actions.set]: (context, newUser) => {
        context.commit(typeUser.mutations.set, newUser);
    },
    [typeUser.actions.reset]: (context) => {
        context.commit(typeUser.mutations.reset);
    },
    [typeUser.actions.hasAccessToMultipleAccounts]: (context, newHasAccessToMultipleAccounts) => {
        context.commit(typeUser.mutations.hasAccessToMultipleAccounts, newHasAccessToMultipleAccounts);
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};
